// import { useState, useEffect } from "react";
// import {
//   Card,
//   CardContent,
//   Typography,
//   Box,
//   Container,
//   CircularProgress,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
// } from "@mui/material";
// import CheckCircleIcon from "@mui/icons-material/CheckCircle";
// import ErrorIcon from "@mui/icons-material/Error";

// export default function ServiceStatus() {
//   const [status, setStatus] = useState("checking");
//   const [services, setServices] = useState([]);
//   const fifteenMinutes = 15 * 60 * 1000;

//   const hostname = window.location.hostname;
//   const env = hostname.includes("dev-status")
//     ? "dev"
//     : hostname.includes("test-status")
//     ? "test"
//     : "dev";

//   const apiUrls = [
//     `https://${env}-api.unify.care/api/workos/health`,
//     `https://${env}-api.unify.care/api/account/health`,
//     `https://${env}-api.unify.care/api/administration/health`,
//     `https://${env}-api.unify.care/api/order/health`,
//     `https://${env}-api.unify.care/api/diagnostic/health`,
//     `https://${env}-api.unify.care/api/fhir/health`,
//     `https://${env}-api.unify.care/api/billing/health`,
//     `https://${env}-api.unify.care/api/payment/health`,
//     `https://${env}-api.unify.care/api/ipd/health`,
//     `https://${env}-api.unify.care/api/nationalhealth/health`,
//     `https://${env}-api.unify.care/api/pharmacy/health`,
//     `https://${env}-api.unify.care/api/translation/health`,
//     `https://${env}-api.unify.care/api/abdm/health`,
//     `https://${env}-api.unify.care/api/healtharticle/health`,
//     `https://${env}-api.unify.care/api/inventory/health`,
//     `https://${env}-admin.unify.care/healths`,
//     `https://${env}-patient.unify.care/healths`,
//     `https://${env}-accounts.unify.care/healths`,
//     `https://${env}-practitioner.unify.care/healths`,
//     `https://${env}-studio.unify.care/healths`,
//     `https://${env}-inventory.unify.care/healths`,
//     `https://${env}-central.unify.care/healths`,
//     `https://${env}.unify.care/healths`,
//   ];

//   const msgObj = {
//     checking: { message: "Checking services...", color: "#fbc02d" },
//     success: { message: "Environment is stable", color: "#19706e" },
//     failure: { message: "Environment is not stable", color: "#d32f2f" },
//   };

//   const extractServiceName = (url) => {
//     // Special case for main environment URL: https://${env}.unify.care/healths
//     if (url === `https://${env}.unify.care/healths`) {
//       return "dev";
//     }

//     if (url.includes("/api/")) {
//       // Backend APIs: example https://dev-api.unify.care/api/workos/health -> "workos-api"
//       const parts = url.split("/");
//       return `${parts[4]}-api`;
//     } else {
//       // Front-end apps (like https://dev-admin.unify.care/healths) -> "admin-app"
//       const domain = url.split("//")[1];
//       const subdomain = domain.split(".")[0];
//       // Remove env prefix from subdomain if exists
//       const serviceName = subdomain.startsWith(`${env}-`)
//         ? subdomain.replace(`${env}-`, "")
//         : subdomain;
//       return `${serviceName}-app`;
//     }
//   };

//   const sendChatWebhook = async (failedServicesList) => {
//     const serviceNames = failedServicesList.map((s) => `• ${s.name}`).join("\n");
//     const message = {
//       text: `*Service status - ${env.toUpperCase()} Environment*\n\nThe following services are DOWN:\n${serviceNames}`,
//     };

//     try {
//       await fetch(
//         "https://chat.googleapis.com/v1/spaces/AAQAi0xFAiE/messages?key=AIzaSyDdI0hCZtE6vySjMm-WEfRq3CPzqKqqsHI&token=L07zkuvdmu8sSfICQg50gV0u3GidX62mP282m39-4Ac",
//         {
//           method: "POST",
//           body: JSON.stringify(message),
//           headers: { "Content-Type": "application/json" },
//         }
//       );
//     } catch (error) {
//       console.error("Failed to send Google Chat message:", error);
//     }
//   };

//   const checkServices = async () => {
//     try {
//       const now = Date.now();
//       const storedAlerts = JSON.parse(localStorage.getItem("lastAlertTimes") || "{}");
//       const updatedAlertTimes = { ...storedAlerts };

//       const results = await Promise.all(
//         apiUrls.map(async (url) => {
//           const name = extractServiceName(url);
//           try {
//             const res = await fetch(url, { cache: "no-store" });
//             const isHealthy = res.status === 200;
//             return { name, isUp: isHealthy };
//           } catch {
//             return { name, isUp: false };
//           }
//         })
//       );

//       const failedServices = results.filter((s) => !s.isUp);
//       const servicesToAlert = [];

//       failedServices.forEach((s) => {
//         const lastAlert = storedAlerts[s.name];
//         if (!lastAlert || now - lastAlert >= fifteenMinutes) {
//           servicesToAlert.push(s);
//           updatedAlertTimes[s.name] = now;
//         }
//       });

//       if (servicesToAlert.length > 0) {
//         await sendChatWebhook(servicesToAlert);
//       }

//       const allHealthy = results.every((s) => s.isUp);
//       setStatus(allHealthy ? "success" : "failure");
//       setServices(results);
//       localStorage.setItem("lastAlertTimes", JSON.stringify(updatedAlertTimes));
//     } catch (error) {
//       console.error("Error checking services:", error);
//       setStatus("failure");
//     }
//   };

//   useEffect(() => {
//     checkServices();
//     const interval = setInterval(checkServices, 10 * 60 * 1000);
//     return () => clearInterval(interval);
//   }, []);

//   const failedServices = services.filter((s) => !s.isUp);

//   return (
//     <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh", backgroundColor: "#f4f6f8" }}>
//       <Container
//         sx={{
//           flexGrow: 1,
//           display: "flex",
//           flexDirection: "column",
//           alignItems: "center",
//           justifyContent: "center",
//           paddingTop: "30px",
//         }}
//       >
//         <Card sx={{ minWidth: 400, maxWidth: 600, borderRadius: 3, boxShadow: 4, padding: 3, textAlign: "center" }}>
//           <CardContent
//             sx={{
//               backgroundColor: msgObj[status]?.color,
//               color: "#fff",
//               padding: "24px",
//               borderRadius: "8px",
//             }}
//           >
//             {status === "checking" ? (
//               <CircularProgress color="inherit" size={50} />
//             ) : status === "success" ? (
//               <CheckCircleIcon sx={{ fontSize: 50 }} />
//             ) : (
//               <ErrorIcon sx={{ fontSize: 50 }} />
//             )}
//             <Typography variant="h5" fontWeight="bold" sx={{ marginTop: 2 }}>
//               {msgObj[status]?.message}
//             </Typography>
//             <Typography variant="subtitle1" sx={{ marginBottom: "20px" }}>
//               Services ({services.filter((s) => s.isUp).length}/{services.length})
//             </Typography>
//           </CardContent>
//         </Card>

//         {failedServices.length > 0 && (
//           <TableContainer component={Paper} sx={{ mt: 3, maxWidth: 600 }}>
//             <Table>
//               <TableHead>
//                 <TableRow>
//                   <TableCell sx={{ fontWeight: "bold" }}>Service Name</TableCell>
//                   <TableCell align="center" sx={{ fontWeight: "bold" }}>
//                     Status
//                   </TableCell>
//                 </TableRow>
//               </TableHead>
//               <TableBody>
//                 {failedServices.map((service) => (
//                   <TableRow key={service.name}>
//                     <TableCell>{service.name}</TableCell>
//                     <TableCell align="center" sx={{ color: "#d32f2f" }}>
//                       Down
//                     </TableCell>
//                   </TableRow>
//                 ))}
//               </TableBody>
//             </Table>
//           </TableContainer>
//         )}
//       </Container>
//     </Box>
//   );
// }
import { useState, useEffect } from "react";
import {
  Card,
  CardContent,
  Typography,
  Box,
  Container,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";

export default function ServiceStatus() {
  const [status, setStatus] = useState("checking");
  const [services, setServices] = useState([]);

  const hostname = window.location.hostname;
  const env = hostname.includes("dev-status")
    ? "dev"
    : hostname.includes("test-status")
    ? "test"
    : "dev";

  const apiUrls = [
    `https://${env}-api.unify.care/api/workos/health`,
    `https://${env}-api.unify.care/api/account/health`,
    `https://${env}-api.unify.care/api/administration/health`,
    `https://${env}-api.unify.care/api/order/health`,
    `https://${env}-api.unify.care/api/diagnostic/health`,
    `https://${env}-api.unify.care/api/fhir/health`,
    `https://${env}-api.unify.care/api/billing/health`,
    `https://${env}-api.unify.care/api/payment/health`,
    `https://${env}-api.unify.care/api/ipd/health`,
    `https://${env}-api.unify.care/api/lis/health`,
    `https://${env}-api.unify.care/api/nationalhealth/health`,
    `https://${env}-api.unify.care/api/pharmacy/health`,
    `https://${env}-api.unify.care/api/translation/health`,
    `https://${env}-api.unify.care/api/abdm/health`,
    `https://${env}-api.unify.care/api/healtharticle/health`,
    `https://${env}-api.unify.care/api/inventory/health`,
    `https://${env}-admin.unify.care/healths`,
    `https://${env}-patient.unify.care/healths`,
    `https://${env}-accounts.unify.care/healths`,
    `https://${env}-practitioner.unify.care/healths`,
    `https://${env}-studio.unify.care/healths`,
    `https://${env}-inventory.unify.care/healths`,
    `https://${env}-central.unify.care/healths`,
    `https://${env}.unify.care/healths`,
  ];

  const msgObj = {
    checking: { message: "Checking services...", color: "#fbc02d" },
    success: { message: "Environment is stable", color: "#19706e" },
    failure: { message: "Environment is not stable", color: "#d32f2f" },
  };

  const extractServiceName = (url) => {
    if (url === `https://${env}.unify.care/healths`) {
      return env.charAt(0).toUpperCase() + env.slice(1);
    }
    if (url.includes("/api/")) {
      const parts = url.split("/");
      return `${parts[4]}-api`;
    } else {
      const domain = url.split("//")[1];
      const subdomain = domain.split(".")[0];
      const serviceName = subdomain.startsWith(`${env}-`)
        ? subdomain.replace(`${env}-`, "")
        : subdomain;
      return `${serviceName}-app`;
    }
  };

  const checkServices = async () => {
    try {
      const results = await Promise.all(
        apiUrls.map(async (url) => {
          const name = extractServiceName(url);
          try {
            const res = await fetch(url, { cache: "no-store" });
            const isHealthy = res.status === 200;
            return { name, isUp: isHealthy };
          } catch {
            return { name, isUp: false };
          }
        })
      );

      const allHealthy = results.every((s) => s.isUp);
      setStatus(allHealthy ? "success" : "failure");
      setServices(results);
    } catch (error) {
      console.error("Error checking services:", error);
      setStatus("failure");
    }
  };

  useEffect(() => {
    checkServices();
    const interval = setInterval(checkServices, 10 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  const failedServices = services.filter((s) => !s.isUp);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        backgroundColor: "#f4f6f8",
      }}
    >
      <Container
        sx={{
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          paddingTop: "30px",
        }}
      >
        <Card
          sx={{
            minWidth: 400,
            maxWidth: 600,
            borderRadius: 3,
            boxShadow: 4,
            padding: 3,
            textAlign: "center",
          }}
        >
          <CardContent
            sx={{
              backgroundColor: msgObj[status]?.color,
              color: "#fff",
              padding: "24px",
              borderRadius: "8px",
            }}
          >
            {status === "checking" ? (
              <CircularProgress color="inherit" size={50} />
            ) : status === "success" ? (
              <CheckCircleIcon sx={{ fontSize: 50 }} />
            ) : (
              <ErrorIcon sx={{ fontSize: 50 }} />
            )}
            <Typography variant="h5" fontWeight="bold" sx={{ marginTop: 2 }}>
              {msgObj[status]?.message}
            </Typography>
            <Typography variant="subtitle1" sx={{ marginBottom: "20px" }}>
              Services ({services.filter((s) => s.isUp).length}/
              {services.length})
            </Typography>
          </CardContent>
        </Card>

        {failedServices.length > 0 && (
          <TableContainer component={Paper} sx={{ mt: 3, maxWidth: 600 }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: "bold" }}>
                    Service Name
                  </TableCell>
                  <TableCell align="center" sx={{ fontWeight: "bold" }}>
                    Status
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {failedServices.map((service) => (
                  <TableRow key={service.name}>
                    <TableCell>{service.name}</TableCell>
                    <TableCell align="center" sx={{ color: "#d32f2f" }}>
                      Down
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Container>
    </Box>
  );
}
